import { CenteredLayout } from '@/components/layouts/CenteredLayout';
import { tenantSelector } from '@/features/configuration/configurationSelector';
import { useSelector } from '@/store/utils';
import { useEffect } from 'react';

export const Version = () => {
  const tenant = useSelector(tenantSelector);

  useEffect(() => {
    document.title = `${tenant.value.charAt(0).toUpperCase() + tenant.value.slice(1)} | Version`;
  }, [tenant]);

  return (
    <CenteredLayout>
      <div>
        <div className="grid grid-cols-2 gap-2">
          <span>Version</span>
          <span>{import.meta.env.VITE_APP_VERSION}</span>
        </div>
      </div>
    </CenteredLayout>
  );
};
